import { Card, CardProps, SxProps, Theme } from "@mui/material";
import { forwardRef } from "react";

const BNCard = forwardRef<HTMLInputElement, CardProps>((props, ref) => {
  const { sx: sxInput, ...restOfProps } = props;
  const sx: SxProps<Theme> = [
    {
      overflow: "hidden",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "transparent",
      border: "0.0625rem solid rgba(255, 255, 255, 0.2)",
    },
    (theme: Theme) =>
      theme.applyStyles("dark", {
        borderColor: "rgba(0, 0, 0, 0.5)",
      }),
    ...(Array.isArray(sxInput) ? sxInput : sxInput ? [sxInput] : []),
  ];

  return <Card ref={ref} sx={sx} {...restOfProps}></Card>;
});

export default BNCard;
